import axios from "axios";
import router from "@/router";
import { clearSession, getToken } from "@/composables/useAuth";

const apiBase = process.env.VUE_APP_API_URL || "";

const isApiRequest = (url) => Boolean(url) && url.startsWith(apiBase);

export const setupHttp = () => {
    axios.interceptors.request.use((config) => {
        const token = getToken();

        if (token && isApiRequest(config.url)) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    });

    // A token can expire while the panel is open, so any 401 from the API ends
    // the local session and sends the user back to the login page.
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error?.response?.status;
            const currentRoute = router.currentRoute.value;

            if (status === 401 && isApiRequest(error?.config?.url) && currentRoute.name !== "login") {
                clearSession();

                router.push({
                    name: "login",
                    query: { redirectFrom: currentRoute.fullPath },
                });
            }

            return Promise.reject(error);
        }
    );
};

export default setupHttp;
